import React, { useState, useEffect } from 'react';

const ScrollButton = () => {
	const [visible, setVisible] = useState(false);

	const toggleVisibility = () => {
		if (window.scrollY > 150) {
			setVisible(true);
		} else {
			setVisible(false);
		}
	};

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	useEffect(() => {
		window.addEventListener('scroll', toggleVisibility);
		return () => window.removeEventListener('scroll', toggleVisibility);
	}, []);

	return (
		<button
			onClick={scrollToTop}
			className={`fixed bottom-4 right-4 bg-blue-500/50 text-white px-3 py-1 rounded-full shadow-md hover:bg-gray-300 hover:text-black transition-opacity duration-300 ${
				visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
			}`}
			aria-label="Scroll to top"
		>
			↑
		</button>
	);
};

export default ScrollButton;